import React from 'react';
import styled from 'styled-components/macro';

interface IArrowIconProps {
  $onMinimize: () => void;
  isMinimized: boolean;
  textcolor: string;
}

export default function ArrowIcon({ $onMinimize, isMinimized, textcolor }: IArrowIconProps): JSX.Element {
  return (
    <StyledArrowIcon isMinimized={isMinimized} textcolor={textcolor} $onMinimize={(): void => $onMinimize()}>
      <svg
        onClick={(): void => $onMinimize()}
        width="13"
        height="19"
        viewBox="0 0 13 19"
        fill="gray"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.59756 18.5037C2.04323 18.9909 1.19895 18.9364 0.711803 18.382C0.224661 17.8277 0.279131 16.9834 0.833465 16.4963L2.59756 18.5037ZM10.819 9.5L11.701 8.49629C11.9897 8.74998 12.1552 9.11569 12.1552 9.5C12.1552 9.88431 11.9897 10.25 11.701 10.5037L10.819 9.5ZM0.833465 2.50371C0.279131 2.01657 0.224661 1.17229 0.711803 0.61795C1.19895 0.0636157 2.04323 0.00914571 2.59756 0.496288L0.833465 2.50371ZM0.833465 16.4963L9.93691 8.49629L11.701 10.5037L2.59756 18.5037L0.833465 16.4963ZM9.93691 10.5037L0.833465 2.50371L2.59756 0.496288L11.701 8.49629L9.93691 10.5037Z"
          fill="gray"
        />
      </svg>
    </StyledArrowIcon>
  );
}

const StyledArrowIcon = styled.div<IArrowIconProps>`
  transform: ${({ isMinimized }) => (isMinimized ? 'rotate(0deg)' : 'rotate(180deg)')};
  transition: height width 0.4s ease-in-out;
  cursor: pointer;
  & svg {
    width: 14px !important;
    height: 14px !important;
    & path {
      fill: ${({ textcolor }) => (textcolor === 'white' ? '#fff' : 'gray')} !important;
    }
  }
`;
